var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none",
    rx: 0,
    ry: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17003 16.5975C9.02003 16.5975 8.86003 16.6575 8.75003 16.7775L6.57006 18.9497V3.5976C6.57006 3.2676 6.30006 2.9976 5.97006 2.9976C5.64006 2.9976 5.37006 3.2676 5.37006 3.5976V18.9497L3.19003 16.7775C2.96003 16.5375 2.58003 16.5475 2.34003 16.7775C2.10003 17.0075 2.11003 17.3875 2.34003 17.6275L5.54003 20.8275C5.77003 21.0575 6.15003 21.0575 6.39003 20.8275L9.59003 17.6275C9.82003 17.3975 9.82003 17.0175 9.59003 16.7775C9.48003 16.6575 9.32003 16.5975 9.17003 16.5975ZM21.97 11.3977H9.17001C8.84001 11.3977 8.57001 11.6677 8.57001 11.9977C8.57001 12.3277 8.84001 12.5977 9.17001 12.5977H21.97C22.3 12.5977 22.57 12.3277 22.57 11.9977C22.57 11.6677 22.3 11.3977 21.97 11.3977ZM9.17001 7.19751H17.97C18.3 7.19751 18.57 7.46751 18.57 7.79751C18.57 8.12751 18.3 8.39751 17.97 8.39751H9.17001C8.84001 8.39751 8.57001 8.12751 8.57001 7.79751C8.57001 7.46751 8.84001 7.19751 9.17001 7.19751ZM9.17001 2.99755H13.97C14.3 2.99755 14.57 3.26756 14.57 3.59756C14.57 3.92756 14.3 4.19756 13.97 4.19756H9.17001C8.84001 4.19756 8.57001 3.92756 8.57001 3.59756C8.57001 3.26756 8.84001 2.99755 9.17001 2.99755Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.50a7c2473a4adcd86196c14c47f26c2b.svg";
export { ForwardRef as ReactComponent };